import { render, staticRenderFns } from "./TransferSiteModal.vue?vue&type=template&id=5934ed22&"
import script from "./TransferSiteModal.vue?vue&type=script&lang=js&"
export * from "./TransferSiteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports